import { render, staticRenderFns } from "./ProcessTask.vue?vue&type=template&id=2974d569&scoped=true"
import script from "./ProcessTask.vue?vue&type=script&lang=js"
export * from "./ProcessTask.vue?vue&type=script&lang=js"
import style0 from "./ProcessTask.vue?vue&type=style&index=0&id=2974d569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974d569",
  null
  
)

export default component.exports